module.exports = __webpack_public_path__ + "img/strings.7781fc6f.svg";